import * as React from 'react';
import { Box, Dialog, DialogContent, DialogTitle, Divider, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import NeedHelp from '../../assets/images/needHelp.png';
import '../../assets/scss/appBar.scss';
const NeedHelpDialog = ({ open, onClose, supportEmail }) => {
    const [t] = useTranslation('global');
    const resolvedEmail = supportEmail || process.env.NEED_HELP_SUPPORT_EMAIL || '';
    return (React.createElement(Dialog, { open: open, onClose: onClose, className: 'revamp-need-help-dialog', maxWidth: 'sm', fullWidth: true },
        React.createElement(DialogTitle, { className: 'revamp-need-help-title' },
            t('NeedHelp.Heading'),
            React.createElement(IconButton, { onClick: onClose, className: 'revamp-need-help-close', size: 'small' },
                React.createElement(CloseIcon, { sx: { fontSize: 20, color: '#1F2937' } }))),
        React.createElement(Divider, { style: { marginLeft: 20, marginRight: 20 } }),
        React.createElement(DialogContent, { className: 'revamp-need-help-content' },
            React.createElement(Box, { className: 'revamp-need-help-illustration' },
                React.createElement("img", { src: NeedHelp, alt: 'Need Help' })),
            React.createElement(Typography, { className: 'revamp-need-help-text' }, t('NeedHelp.PleaseReachOut')),
            React.createElement(Typography, { component: 'a', href: `mailto:${resolvedEmail}`, target: '_blank', rel: 'noopener noreferrer', className: 'revamp-need-help-email' }, resolvedEmail))));
};
export default NeedHelpDialog;
